module.exports = __webpack_public_path__ + "media/bgm.e902d56d.mp3";